import BaseTabs from '@material-ui/core/Tabs'

const Tabs = BaseTabs

export default Tabs
